<template>
    <el-col :md="10" :class="classes" style="margin-bottom: 10px;">
        <el-form-item v-bind:class="'item-fome-base'" :label="label">
            <textarea 
                autocomplete="off" 
                rows="5"
                class="el-textarea__inner" 
                style="min-height: 33px;" 
                :value="value"
                @input="$emit('input', $event.target.value)" 
            />
            <div class="text-left">
                <label v-if="error" class="text-danger text-left"> {{ error.msg }} </label>
            </div>
        </el-form-item>
    </el-col>
</template>

<script>
export default {
    components: {},

    props: [
        "error",
        "value",
        "classes",
        "label",
    ],
}
</script>